import { Styles as Messaging } from '@studio/design-system/messaging';
import type { Status } from '@studio/models/agent';
import type { ValueOf } from 'type-fest';

/** Shared styles. */
export const Styles = Object.freeze({
  status: {
    'idle': Messaging.warning,
    'booting': Messaging.warning,
    'offline': Messaging.error,
    'offline-embedded': Messaging.error,
    'online': Messaging.success
  } satisfies Record<Status, ValueOf<typeof Messaging>>
});
